import { createContext } from 'react';

import KeyGroup from '../../../interfaces/keyGroup';

export interface KeyGroupContextValue {
	isLoading: boolean;
	hasError: boolean;
	keyGroup: KeyGroup | undefined;
	overwrittenClientId: string | undefined;
}

const KeyGroupContext = createContext<KeyGroupContextValue>({
	isLoading: true,
	hasError: false,
	keyGroup: undefined,
	overwrittenClientId: undefined,
});

export default KeyGroupContext;
